import moment from "moment";
import React from "react";
import NoImage from "../assets/images/no-image.jpeg";
import NoLogo from "../assets/images/model_no_logo.png";
import { Icon } from "@iconify/react/dist/iconify.js";
export default class Helpers {

  //Check is value is not null && not undefined
  static isValid(value) {
    if (value !== undefined) return true;
    if (value !== null) return true;
    return false;
  }

  //Check if value contain number only
  static isContainNumberOnly(value) {
    return /^\d+$/.test(value);
  }

  //Check if value contain number only
  static validateDecimal(input) {
    const regex = /^[0-9]*\.?[0-9]*$/;
    return regex.test(input);
  }

  //Check if value is null or empty
  static isNullOrEmpty(value) {
    return value === undefined || !value || value === null || value === '' || value === 'undefined';
  }

  static nricFormatter = (value) => {
    let string = value.slice(0, 6) + "-" + value.slice(6, 8) + "-" + value.slice(8)
    return string;
  }

  //Check if array is null or empty
  static isArrayNullOrEmpty(value) {
    return value === undefined || !value || value === null || value === '' || typeof value !== "object" || value === 'undefined' || value?.length < 0;
  }

  //Check if NRIC validation
  static nricValidation = (value) => {
    if (value == "" || value == null) {
      return true;
    } else if (!this.isContainNumberOnly(value)) {
      return true;
    } else if (value.length < 12 || value.length > 12) {
      return true;
    } else {
      return false;
    }
  };

  static nameValidation = (name) => {
    if (name === "" || name === null) {
      return true;
    } else if (/\d/.test(name)) {
      return true;
    } else if (name.charAt(0) === " " || name.charAt(name.length - 1) === " ") {
      return true;
    } else if (name.length < 3) {
      return true;
    } else if (name.includes("  ")) {
      return true;
    } else if (
      name.includes("!") ||
      name.includes("#") ||
      name.includes("$") ||
      name.includes("%") ||
      name.includes("^") ||
      name.includes("*") ||
      name.includes("_") ||
      name.includes("+") ||
      name.includes("=") ||
      name.includes("|") ||
      name.includes("<") ||
      name.includes(">") ||
      name.includes("?") ||
      name.includes(`"`) ||
      name.includes(",") ||
      name.includes(":") ||
      name.includes(";") ||
      name.includes("{") ||
      name.includes("}") ||
      name.includes("[") ||
      name.includes("]") ||
      name.includes("~") ||
      name.includes("`")
    ) {
      return true;
    } else if (/(.)\1\1\1/.test(name)) {
      return true;
    } else {
      return false;
    }
  };

  static phoneNumberValidation = (value) => {
    // value = value.replaceAll("-", "");
    if (value == "") {
      return true;
    }
    else if (!this.isContainNumberOnly(value)) {
      return true;
    }
    // Temporary disabled
    // else if (value.charAt(3) != "1") {
    //   return Labels.ERROR_MOBILE_NUMBER;
    // }
    // else if (value.charAt(0) == "0") {
    //   return true;
    // } 
    else if (value.substring(0, 2) == "11" && value.length < 9) {
      return true;
    } else if (
      (value.substring(0, 2) == "10" ||
        value.substring(0, 2) == "12" ||
        value.substring(0, 2) == "13" ||
        value.substring(0, 2) == "14" ||
        value.substring(0, 2) == "15" ||
        value.substring(0, 2) == "16" ||
        value.substring(0, 2) == "17" ||
        value.substring(0, 2) == "18" ||
        value.substring(0, 2) == "19") &&
      value.length < 9
    ) {
      return true;
    } else {
      return false;
    }
  };


  static emailValidation = (value) => {
    const reg =
      /^[a-zA-Z0-9&(),./_\-]+@[a-zA-Z0-9]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/;

    if (this.isNullOrEmpty(value)) {
      return true;
    } else if (value.length > 60) {
      return true;
    } else if (value.charAt(0) === " ") {
      return true;
    } else if (!reg.test(value)) {
      return true;
    } else if (value.charAt(value.length - 1) === " ") {
      return true;
    } else {
      return false;
    }
  };

  static phoneLengthValidation = (value) => {
    if (value.length >= 9) {
      return true
    }
    else
      return false
  };



  static getYearList = () => {
    let yearArr = [];
    let thisYear = (new Date()).getFullYear();
    for (let i = 0; i <= 60; i++) {
      const year = thisYear - i;
      yearArr.push(year);
    }
    return yearArr;
  };

  static lastDayOfMonth(Year, Month) {
    return new Date((new Date(Year, Month, 1)) - 1);
  }

  static getMonthList = (index) => {
    let month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return month;
  };

  //Covert string to capitalize
  static capitalize(string) {
    if (string)
      return string[0].toUpperCase() + string.substr(1).toLowerCase()
    else
      return
  }

  static getErrorMsg = (code) => {
    switch (code) {
      case "validation_failed":
        return "Please fill in all required fields.";
      case "create_failed":
        return "Failed to create.";
      case "update_failed":
        return "Failed to update.";
      default:
        return code;
    }
  }

  static capitalizeWords(str) {
    if (str?.length > 0 || !this.isNullOrEmpty(str)) {
      return str
        .toLowerCase()
        .split(' ')
        .map(function (word) {
          return word?.length > 0 ? word[0].toUpperCase() + word.substr(1) : '';
        })
        .join(' ');
    } else {
      return ''
    }

  }

  static convertToMB(size) {
    return (size / (1024 * 1024)).toFixed(2);
  }

  //Format number
  static formatNumber(num) {
    let value = num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    if (value === "NaN") {
      return 0;
    }
    return value;
  }

  static getUniqueListBy(arr, key) {
    return [...new Map(arr.map(item => [item[key], item])).values()]
  }

  //Format number with commas
  static numberWithCommas(x) {
    if (x) {
      let number = Number(x).toFixed(2);
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
      return '';
    }

  }

  static downloadBinary(response, filename) {
    let a = document.createElement('a');
    a.href = window.URL.createObjectURL(new Blob([response]))
    a.download = filename
    document.body.appendChild(a)
    a.click();
    document.body.removeChild(a)
  }

  static truncateString(str, num) {
    // If the length of str is less than or equal to num
    // just return str--don't truncate it.
    if (str.length <= num) {
      return str;
    }
    // Return str truncated with '...' concatenated to the end of str.
    return str.slice(0, num) + "...";
  }


  static addFirstItemInArray(arr, object) {
    return [object].concat(arr)
  }

  static validatePassword(value, name) {
    let expregular = "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[_!@#\$%\^&\*])(?=.{8,})";
    let error = null;
    if (!value) {
      error = `Please enter ${name} password.`;
    } else if (!value.match(expregular)) {
      error = "Password must contain between 8-16 characters, with upper case, lower case, special character and numeric characters.";
    }
    return error
  }

  static validateUserName(value, name) {
    let error = null;
    if (!value) {
      error = `Please enter user name`;
    }
    return error
  }

  static validateField(value, name) {
    let error = null;
    if (!value) {
      error = `Please enter ${name}`;
    }
    return error
  }

  //compareDateToCurrentDate (yyyy-mm-dd)
  static compareDateToCurrentDate(date) {
    var today = new Date().setHours(0, 0, 0, 0);
    var eventOn = new Date(date).setHours(0, 0, 0, 0);
    let type = "";
    if (today < eventOn) {
      type = "incoming";
    } else if (today > eventOn) {
      type = "pass";
    } else {
      type = "today";
    }
    return type;
  }

  static replaceBulk(str, findArray, replaceArray) {
    var i, regex = [], map = {};
    for (i = 0; i < findArray.length; i++) {
      regex.push(findArray[i].replace(/([-[\]{}()*+?.\\^$|#,])/g, '\\$1'));
      map[findArray[i]] = replaceArray[i];
    }
    regex = regex.join('|');
    str = str.replace(new RegExp(regex, 'g'), function (matched) {
      return map[matched];
    });
    return str;
  }
  //field need to search , and value 
  static findItemInArray(list, field, value) {
    let item = [];
    item = list.filter(
      function (ev) {
        return ev[field] == value;
      }
    );
    return item
  }

  static displayStatusString(value) {
    let status = '';
    status = value === 'pending' ? "Pending Order" :
      value === 'confirmed' || value === 'ordered' ? "Confirmed" :
        value === 'payment_failed' ? "Payment Failed" :
          value === 'closed' ? "Closed" :
            value === 'cancelled' ? "Cancelled" :
              value === 'shipped' ? "Shipped" :
                value === 'delivered' ? "Delivered" :
                  value === 'refunded' ? "Refunded" :
                    value === 'pending_approval' ? "Pending Approval" :
                      value === 'published' ? "Published" :
                        value === 'rejected' ? "Rejected" :
                          "Partially Refunded"
    return status;
  }

  static displayReviewStatusString(value) {
    let status = '';
    status = value === 'pending_approval' ? "Pending Approval" :
      value === 'approved' ? "Published" : "Rejected"
    return status;
  }

  static displayProductStatusString(value) {
    let status = '';
    status = value === 2 ? "Pending Approval" :
      value === 1 ? "Published" :
        "Unpublished"
    return status;
  }

  static displayTaskStatusString(value) {
    let status = '';
    status = value === 'pending' ? "Pending Confirmed" :
      value === 'rescheduled' ? "Rescheduled" :
        value === 'confirmed' ? "Confirmed" :
          value === 'completed' ? "Completed" :
            "Closed"
    return status;
  }

  static displayAssetStatusString(value) {
    let status = '';
    status = value === 'maintenance' ? "Under Maintenance" :
      value === 'operational' ? "Operational" :
        value === 'repair_scheduled' ? "Scheduled for repair" :
          value === 'inspection_due' ? "Inspection Due" :
            "Breakdown";
    return status;
  }

  static createDateOptions = [
    { label: 'Today', value: 'today' },
    { label: 'Yesterday', value: 'yesterday' },
    { label: 'This week', value: 'week' },
    { label: 'Last week', value: 'last_week' },
    { label: 'This month', value: 'month' },
    { label: 'Last month', value: 'last_month' },
    { label: 'This year', value: 'year' },
    { label: 'Last year', value: 'last_year' },
    { label: 'Custom dates', value: 'custom' },
  ]

  static dashboardPeriodOptions = [
    { label: 'Last 7 days', value: 'last_7_days' },
    { label: 'Last 30 days', value: 'last_30_days' },
    { label: 'This month', value: 'this_month' },
    { label: 'Last month', value: 'last_month' },
    { label: 'This year', value: 'this_year' },
    { label: 'Last year', value: 'last_year' },
  ]

  static userType = [
    { value: 'dealer', label: "Dealer", statusColor: 'dark-red' },
    { value: 'personal', label: "Personal", statusColor: 'dark-red' },
    { value: 'verified', label: "Verified", statusColor: 'green-white' },
  ]

  static orderStatus = [
    { value: 'pending', label: "Pending Payment", statusColor: 'light-grey' },
    { value: 'paid', label: "Ready to Ship", statusColor: 'yellow' },
    { value: 'shipped', label: "Shipped", statusColor: 'purple' },
    { value: 'completed', label: "Completed", statusColor: 'green' },
    { value: 'cancelled', label: "Cancelled", statusColor: 'red' },
  ]

  static advertStatus = [
    { value: 'draft', label: "Draft", statusColor: 'light-grey' },
    { value: 'pending_approval', label: "Pending Approval", statusColor: 'yellow' },
    { value: 'published', label: "Published", statusColor: 'blue' },
    { value: 'reserved', label: "Reserved", statusColor: 'orange' },
    { value: 'sold_out', label: "Sold Out", statusColor: 'green' },
    { value: 'inactive', label: "Inactive", statusColor: 'red' },
  ]

  static accessoryStatus = [
    { value: 'Draft', label: "Draft", statusColor: 'light-grey' },
    { value: 'Published', label: "Published", statusColor: 'blue' },
    { value: 'Sold_out', label: "Sold Out", statusColor: 'green' },
    { value: 'Inactive', label: "Inactive", statusColor: 'red' },
  ]

  static profileTeamMemberVerificationStatus = [
    { value: 0, label: "You", statusColor: 'blue' },
    { value: 1, label: "Verified", statusColor: 'mint-green' },
    { value: 2, label: "Unverified", statusColor: 'yellow-orange' },
  ]
  
  static profileTeamMemberStatus = [
    { value: 0, label: "Active", statusColor: 'mint-green' },
    { value: 1, label: "Invited", statusColor: 'light-light-grey' },
    { value: 2, label: "Expired", statusColor: 'yellow-orange' },
    { value: 3, label: "Rejected", statusColor: "vampire-red" },
  ]

  static activeinvoiceStatus = [
    { value: '0', label: "Inactive", statusColor: 'blood-red' },
    { value: '1', label: "Active", statusColor: 'green' },
  ]

  static paymentStatus = [
    { value: 'unpaid', label: "Unpaid", statusColor: 'red' },
    { value: 'paid', label: "Paid", statusColor: 'green' },
  ]

  static timeList = [
    { label: '12:00 AM', value: '00:00' }, { label: '12:30 AM', value: '00:30' },
    { label: '01:00 AM', value: '01:00' }, { label: '01:30 AM', value: '01:30' },
    { label: '02:00 AM', value: '02:00' }, { label: '02:30 AM', value: '02:30' },
    { label: '03:00 AM', value: '03:00' }, { label: '03:30 AM', value: '03:30' },
    { label: '04:00 AM', value: '04:00' }, { label: '04:30 AM', value: '04:30' },
    { label: '05:00 AM', value: '05:00' }, { label: '05:30 AM', value: '05:30' },
    { label: '06:00 AM', value: '06:00' }, { label: '06:30 AM', value: '06:30' },
    { label: '07:00 AM', value: '07:00' }, { label: '07:30 AM', value: '07:30' },
    { label: '08:00 AM', value: '08:00' }, { label: '08:30 AM', value: '08:30' },
    { label: '09:00 AM', value: '09:00' }, { label: '09:30 AM', value: '09:30' },
    { label: '10:00 AM', value: '10:00' }, { label: '10:30 AM', value: '10:30' },
    { label: '11:00 AM', value: '11:00' }, { label: '11:30 AM', value: '11:30' },
    { label: '12:00 PM', value: '12:00' }, { label: '12:30 PM', value: '12:30' },
    { label: '01:00 PM', value: '13:00' }, { label: '01:30 PM', value: '13:30' },
    { label: '02:00 PM', value: '14:00' }, { label: '02:30 PM', value: '14:30' },
    { label: '03:00 PM', value: '15:00' }, { label: '03:30 PM', value: '15:30' },
    { label: '04:00 PM', value: '16:00' }, { label: '04:30 PM', value: '16:30' },
    { label: '05:00 PM', value: '17:00' }, { label: '05:30 PM', value: '17:30' },
    { label: '06:00 PM', value: '18:00' }, { label: '06:30 PM', value: '18:30' },
    { label: '07:00 PM', value: '19:00' }, { label: '07:30 PM', value: '19:30' },
    { label: '08:00 PM', value: '20:00' }, { label: '08:30 PM', value: '20:30' },
    { label: '09:00 PM', value: '21:00' }, { label: '09:30 PM', value: '21:30' },
    { label: '10:00 PM', value: '22:00' }, { label: '10:30 PM', value: '22:30' },
    { label: '11:00 PM', value: '23:00' }, { label: '11:30 PM', value: '23:30' },
  ];

  static noticeContentByStatus = [
    {
      status: 'pending_approval',
      title: 'Your advert has been submitted and is awaiting admin review.',
      description: 'You will be notified once it’s approved or if any changes are required.',
      iconName: 'solar:clock-circle-linear',
      backgroundColor: '#F0F0F0',
      borderColor: '#1D1B1B',
      iconColor: '#1D1B1B',
      hasActionButton: false,
    },
    {
      status: 'published',
      title: 'Your Advert Is Nearing Expiry',
      description: <div >This advert will expire in <span className="text-bold">{`3 days`}</span>. Renewing will require <span className="text-bold">{`10 credits`}</span>. Make sure you have enough credits to proceed.</div>,
      iconName: 'solar:danger-triangle-linear',
      backgroundColor: '#F4C06D33',
      borderColor: '#F4C06D',
      iconColor: '#1D1B1B',
      hasActionButton: true,
    },
    {
      status: 'expired',
      title: <div style={{ color: '#D13536' }}>This advert has expired and is no longer visible to buyers.</div>,
      description: <div style={{ color: '#D13536' }}>You can renew the advert to make it active again.</div>,
      iconName: 'solar:danger-triangle-linear',
      backgroundColor: '#FFE9E9',
      borderColor: '#D13536',
      iconColor: '#D13536',
      hasActionButton: true,
    },
    {
      status: 'sold_out',
      title: <div style={{ color: '#11812E' }}>You’ve marked this advert as sold.</div>,
      description: <div style={{ color: '#11812E' }}>This listing is no longer visible to buyers.</div>,
      iconName: 'ri:check-line',
      backgroundColor: '#34C75926',
      borderColor: '#11812E',
      iconColor: '#11812E',
      hasActionButton: false,
    },
  ]

  static licenceCategoryList = [{ label: 'Class 2B (Up to 200cc)', value: 3 }, { label: 'Class 2A (Up to 400cc)', value: 1 }, { label: 'Class 2 (Over 400cc)', value: 2 }]
  static transmissionList = [{ label: 'Automatic', value: 1 }, { label: 'Manual', value: 2 }, {label: 'CVT', value: 3}]
  static vehicleSourceList = [{label: 'Agent Unit', value: 1}, {label: 'Parallel Importer Unit', value: 2}]

  //filter list
  static getSortStatus = (sort, sort_by, sortByName, sortByName2) => {
    if (sort_by === (sortByName || "name") && sort === "asc") return 1;
    else if (sort_by === (sortByName || "name") && sort === "desc") return 2;
    else if (sort_by === (sortByName2 || "inventory") && sort === "asc") return 3;
    else if (sort_by === (sortByName2 || "inventory") && sort === "desc") return 4;
    else return 0
  }

  //filter list
  static getSortStatusLabel = (e, sortByName, sortByName2) => {
    if (e == 1) return { sort_by: (sortByName || "name"), sort: "asc" };
    else if (e == 2) return { sort_by: (sortByName || "name"), sort: "desc" };
    else if (e == 3) return { sort_by: (sortByName2 || "inventory"), sort: "asc" };
    else if (e == 4) return { sort_by: (sortByName2 || "inventory"), sort: "desc" };
    else return { sort_by: "", sort: "" };
  }

  static statusList = [
    { id: 1, name: 'Active' },
    { id: 0, name: 'InActive' },
  ]

  static base64ToBlob = (base64) => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: 'application/pdf' });
  };

  static handleOpenPdfInNewTab = (base64Pdf) => {
    const blob = this.base64ToBlob(base64Pdf);
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  };

  static isFileSizeValid = (file, size = 1) => {
    const maxSizeInBytes = size * 1024 * 1024; // 1MB in bytes
    return file.size <= maxSizeInBytes;
  };

  static formatBytes = (bytes) => {
    if (bytes === 0) return '0 KB';
    const kb = bytes / 1024;
    return `${kb.toFixed(2)} KB`;
  }

  static handleDownload = (base64Pdf, filename) => {
    let date = moment(new Date()).format("YYYYMMDDhhmmss");
    const linkSource = `data:application/pdf;base64,${base64Pdf}`;
    const downloadLink = document.createElement("a");
    const fileName = filename;
    downloadLink.href = linkSource;
    downloadLink.download = `${fileName}_${date}`;
    downloadLink.click();
  }

  static handleDownloadDocument(link, fileName, completeFilename = false) {

    let date = moment(new Date()).format("YYYYMMDDhhmmss");
    fetch(link)
      .then(res => res.blob())
      .then(blob => {
        const blobUrl = window.URL.createObjectURL(blob);
        const downloadLink = document.createElement('a');
        downloadLink.href = blobUrl;
        downloadLink.download = `${fileName}${!completeFilename ? `_${date}.${this.getFileExtension(link)}` : ''}`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        window.URL.revokeObjectURL(blobUrl);
      });
  }

  static handleDownloadExcelFile(base64Data, fileName) {
    let date = moment(new Date()).format("YYYYMMDDhhmmss");
    const downloadLink = document.createElement('a');
    downloadLink.href = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + base64Data;
    downloadLink.download = `${fileName}_${date}`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  static getFileExtension = (file) => {
    if (!file) return '';
    // If file is a string (URL or base64)
    if (typeof file === 'string') {
      // Check for base64 data URL
      const base64Match = file.match(/^data:([a-zA-Z0-9\/\-\+\.]+);base64,/);
      if (base64Match) {
        // Try to extract extension from MIME type
        const mime = base64Match[1];
        const mimeToExt = {
          'application/pdf': 'pdf',
          'image/jpeg': 'jpg',
          'image/png': 'png',
          'image/gif': 'gif',
          'image/bmp': 'bmp',
          'image/svg+xml': 'svg',
          'application/msword': 'doc',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
          'application/vnd.ms-excel': 'xls',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
          'text/plain': 'txt',
          'text/csv': 'csv',
          'application/zip': 'zip',
          'application/json': 'json'
        };
        return mimeToExt[mime] || mime.split('/')[1] || '';
      }
      // Otherwise, treat as URL
      const urlParts = file.split('?')[0].split('#')[0].split('.');
      if (urlParts.length > 1) {
        return urlParts[urlParts.length - 1].toLowerCase();
      }
      return '';
    }
    // If file is a File object
    if (file.name) {
      const nameParts = file.name.split('.');
      if (nameParts.length > 1) {
        return nameParts[nameParts.length - 1].toLowerCase();
      }
    }
    return '';
  }

  static handleRetrieveToken() {
    let isRemember = localStorage.getItem("remember");
    let token = JSON.parse(localStorage.getItem("token"))
    if ((isRemember === 'false' || isRemember === false) && !token) {
      token = JSON.parse(localStorage.getItem("token"))
    }
    return token;
  }

  static convertToCustomTitleCase(input) {
    if (input === "return_refund") {
      return input
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' / ');
    }

    return input
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  static getValueFromData(data, id, returnValue) {
    if (!Array.isArray(data) || data.length === 0) {
      return <span>-</span>;
    }
    const filteredValue = data.find((item) => item.id === id);
    const value = filteredValue?.[returnValue];
    return value ? this.capitalize(value) : <span>-</span>;
  }

  static getValueFromDataForTab(data, id, setValue) {
    if (!Array.isArray(data) || data.length === 0) {
      return <span>-</span>;
    }
    setValue({
      id: data?.[id]?.id,
      name: data?.[id]?.name,
      icon: data?.[id]?.icon
    })
  }


  static getValueFromDataForProductSpecTab(data, id, setValue) {
    if (!Array.isArray(data) || data.length === 0) {
      return <span>-</span>;
    }
    setValue({
      id: data?.[id]?.descriptions?.[0]?.id,
      name: data?.[id]?.descriptions?.[0]?.name,
      icon: data?.[id]?.descriptions?.[0]?.icon,
    })
  }

  static getTabIdFromIndex(data, id) {
    if (!Array.isArray(data) || data.length === 0) {
      return <span>-</span>;
    }
    const filteredValue = data[id]?.id;
    return filteredValue;
  }

  static getArrayInfo(data, id, info) {
    const filteredValue = data?.find((item) => item.id === id);
    const value = filteredValue?.[info];
    return value || <span>-</span>;
  }

  static openTabs() {
    const openTabs = parseInt(localStorage.getItem("openTabs") || "0", 10) + 1;
    localStorage.setItem("openTabs", openTabs);
  }
  static getPreviewBase64(file, set) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      set(reader.result)
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  static getBase64(file, set) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      // Remove the `data:image/jpeg;base64,` or similar prefix
      const base64String = reader.result.split(',')[1]; // Split by comma and get the second part
      set(base64String);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }
  static imageToBase64Sync(url, callback) {
    if (!Helpers?.isValidURL(url)) {
      callback(url);
      return;
    }

    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const reader = new FileReader();
        reader.onloadend = () => callback(reader.result); // Pass Base64 when ready
        reader.readAsDataURL(blob);
      })
      .catch(error => {
        console.error("Error converting image:", error);
        callback(url); // Return original URL if fetch fails
      });
  }

  static isValidURL(url) {
    try {
      new URL(url);
      return true;
    } catch (_) {
      return false;
    }
  }

  static getBase64Arry(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function () {
        const base64String = reader.result.split(',')[1]; // Get base64 string
        resolve(reader.result);
      };

      reader.onerror = function (error) {
        reject(error);
      };
    });
  }

  static getCustomErrorMessageByPrefix(errors, prefix, errorMsg) {
    const hasErrors = Object.entries(errors).some(([key, value]) => key.startsWith(prefix));

    if (hasErrors) {
      return errorMsg || `Some fields are invalid or incomplete.`;
    }

    return null;
  }


  static getCustomErrorMessageByPrefixCard(errors, prefix, errorMsg) {
    const hasErrors = Object.entries(errors).some(([key, value]) => key.startsWith(prefix));

    if (hasErrors) {
      return errorMsg || `Some fields are invalid or incomplete.`;
    }

    return null;
  }


  static createDropdown = (data) => {
    const transformedData = data && Object.keys(data).map((key) => ({
      value: key,  // Convert the string key to a number
      label: data[key]   //
    }));

    return transformedData
  }

  static HTMLRenderer = ({ htmlContent }) => {
    // Sanitize the HTML content before rendering  
    return (
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    );
  };

  static routeToLogin = () => {
    return (window.location.href = "/login")
  }

  static noImage = NoImage;

  static noLogo = NoLogo;

  static searchInterval = 800;

  static checkIcon = () => {
    return (
      <div style={{ backgroundColor: '#D7114D', borderRadius: 3, border: '2px solid #D7114D', color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', width: 18, height: 18, }}>
        <Icon icon={'fluent:checkmark-12-filled'} style={{ color: 'white', margin: 0, padding: 0, height: 12, width: 12 }} />
      </div>
    )
  }

  static status = [
    { value: "all", label: "All statuses" },
    { value: "1", label: "Active" },
    { value: "0", label: "Inactive" },
  ]

  static yesNolist = [
    { value: "1", label: "Yes" },
    { value: "0", label: "No" },
  ]

  static gender = [
    { value: "Female", label: "Female" },
    { value: "Male", label: "Male" },
    // { value: "Other", label: "Other" },
  ]

  static nationalities = [
    { value: "Malaysian", label: "Malaysian" },
    { value: "Non-Malaysian", label: "Non-Malaysian" },
  ]

  static state = [
    { value: "1", label: "Johor" },
    { value: "2", label: "Kedah" },
    { value: "3", label: "Kelantan" },
    { value: "4", label: "Melaka" },
    { value: "5", label: "Negeri Sembilan" },
    { value: "6", label: "Pahang" },
    { value: "7", label: "Pulau Pinang" },
    { value: "8", label: "Perak" },
    { value: "9", label: "Perlis" },
    { value: "10", label: "Selangor" },
    { value: "11", label: "Terengganu" },
    { value: "12", label: "Sabah" },
    { value: "13", label: "Sarawak" },
    { value: "14", label: "WP Kuala Lumpur" },
    { value: "15", label: "WP Labuan" },
    { value: "16", label: "WP Putrajaya" },
  ]

  static async urlToFile(url, filename, mimeType) {
    const res = await fetch(url);
    const buffer = await res.arrayBuffer();
    return new File([buffer], filename, { type: mimeType });
  }

}
